import { NativeTimerType } from '@signageos/common-types/dist/Device/Timer/NativeTimerType';

/**
 * @deprecated use NativeTimerType from `@signageos/common-types/dist/Device/Timer/NativeTimerType`
 */
enum NumberTimerType {
	TIMER_1 = 0,
	TIMER_2 = 1,
	TIMER_3 = 2,
	TIMER_4 = 3,
	TIMER_5 = 4,
	TIMER_6 = 5,
	TIMER_7 = 6,
}

export default NumberTimerType;

export const numberToNativeTimerType = (type: NumberTimerType) => NumberTimerType[type] as NativeTimerType;
